export enum JobStatus {
    SCHEDULED = 'Zaplanowana',
    IN_PROGRESS = 'W trakcie',
}
